export default __webpack_public_path__ + "static/gwp-sub-banner-mobile-e406ee221d0ca175d87a30ddb6e2e019.webp";